import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { logoutUser, closeSSEConnection } from "store/actions";
import { forbidExtraProps } from "utils";

import { ReactComponent as UserIcon } from "assets/images/app_svg/nav_user.svg";

function profile(props) {
  return (
    <React.Fragment>
      <span className="icon">
        <UserIcon />
      </span>
      {props.showDropdown && (
        <div className="profile_dropdown">
          <ul className="profile_ul">
            <li className="user_name">
              <div className="user_name_wrap">
                <span className="name">{props.userDetails.firstname}</span>
                <span className="email">{props.userDetails.emailid}</span>
              </div>

              {props.ecommerceFlag === "O" ||
              props.origin === "ibackup" ||
              props.origin === "idrive" ? null : (
                <NavLink
                  to="/mirror/account"
                  className="common_btn btn_primary"
                >
                  My Account
                </NavLink>
              )}
            </li>
            <li className="profile_li">
              <NavLink
                className="logout"
                to="/mirror/login"
                onClick={() => {
                  props.closeSSEConnection();
                  props.logoutUser(
                    true,
                    props.ecommerceFlag === "O" ||
                      props.origin === "ibackup" ||
                      props.origin === "idrive"
                      ? props.origin
                      : undefined
                  );
                }}
              >
                Logout
              </NavLink>
            </li>
          </ul>
        </div>
      )}
    </React.Fragment>
  );
}

profile.propTypes = forbidExtraProps(
  {
    showDropdown: PropTypes.bool
  },
  ["logoutUser", "userDetails", "ecommerceFlag", "origin", "closeSSEConnection"]
);

function mapStateToProps(state) {
  return {
    userDetails: state.account.userDetails,
    ecommerceFlag: state.account.ecommerceFlag,
    origin: state.account.origin
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logoutUser,
      closeSSEConnection
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(profile);
